export const overlayStyles = {
  position: 'fixed',
  inset: 0,
  zIndex: ({ zIndex }) => zIndex.modal,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: ({ palette }) => palette.primary.main,
  color: ({ palette }) => palette.primary.contrastText,
  paddingTop: 'calc(48px + env(safe-area-inset-top, 0px))',
  paddingBottom: 'calc(32px + env(safe-area-inset-bottom, 0px))',
  paddingLeft: '24px',
  paddingRight: '24px',
};

export const identityStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
  textAlign: 'center',
};

export const callerNameStyles = {
  color: ({ palette }) => palette.primary.contrastText,
};

export const callerNumberStyles = {
  color: ({ palette }) => palette.primary.contrastText,
  opacity: 0.8,
};

export const stateLabelStyles = {
  color: ({ palette }) => palette.primary.contrastText,
  opacity: 0.9,
  marginTop: '4px',
};

export const timerStyles = {
  color: ({ palette }) => palette.primary.contrastText,
  opacity: 0.9,
};

export const spacerStyles = {
  flex: 1,
};

export const dtmfGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '12px',
  width: '100%',
  maxWidth: '300px',
  marginBottom: '24px',
};

export const dtmfButtonStyles = {
  height: '56px',
  borderRadius: '12px',
  border: 'none',
  cursor: 'pointer',
  backgroundColor: ({ palette }) => palette.action.hover,
  color: ({ palette }) => palette.primary.contrastText,
  fontSize: '20px',
  fontWeight: 500,
  WebkitTapHighlightColor: 'transparent',
  '&:active': {
    backgroundColor: ({ palette }) => palette.action.selected,
  },
};

export const controlGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '24px',
  width: '100%',
  maxWidth: '240px',
  justifyItems: 'center',
  marginBottom: '40px',
};

export const controlCellStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
};

export const controlButtonStyles = {
  width: '64px',
  height: '64px',
  borderRadius: '50%',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: ({ palette }) => palette.action.hover,
  color: ({ palette }) => palette.primary.contrastText,
  WebkitTapHighlightColor: 'transparent',
  '&:active': {
    backgroundColor: ({ palette }) => palette.action.selected,
  },
};

export const controlButtonActiveStyles = {
  ...controlButtonStyles,
  backgroundColor: ({ palette }) => palette.primary.contrastText,
  color: ({ palette }) => palette.primary.main,
};

export const controlLabelStyles = {
  color: ({ palette }) => palette.primary.contrastText,
  opacity: 0.9,
};

export const primaryActionsRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '64px',
  width: '100%',
};

export const hangupButtonStyles = {
  width: '72px',
  height: '72px',
  borderRadius: '50%',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: ({ palette }) => palette.error.main,
  color: ({ palette }) => palette.error.contrastText,
  WebkitTapHighlightColor: 'transparent',
  '&:active': {
    backgroundColor: ({ palette }) => palette.error.dark,
  },
};

export const answerButtonStyles = {
  width: '72px',
  height: '72px',
  borderRadius: '50%',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: ({ palette }) => palette.success.main,
  color: ({ palette }) => palette.success.contrastText,
  WebkitTapHighlightColor: 'transparent',
  '&:active': {
    backgroundColor: ({ palette }) => palette.success.dark,
  },
};

export const primaryActionCellStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
};
